import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Grid from 'react-bootstrap/lib/Grid';
import Button from 'react-bootstrap/lib/Button';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import Loader from '../../../components/Loader';
import Link from '../../Link';
import WishListGroupModal from '../WishListGroupModal';
import NotFound from '../../../routes/notFound/NotFound';
import CommonListingItems from '../../Common/ImageUploadComponent/CommonListingItems/CommonListingItems';
import ConfirmationPopup from '../../Common/ConfirmationPopup/ConfirmationPopup';

import { openAddWishListGroupModal, openDeleteWishlistModal, closeDeleteWishlistModal } from '../../../actions/WishList/modalActions';
import { deleteWishListGroup } from '../../../actions/WishList/deleteWishListGroup';
import messages from '../../../locale/messages';
import getWishListGroupQuery from './getWishListGroup.graphql';
import { DustPinIcon, EditIcon, LinkIndicatePrevIcon } from '../../Common/Assets/SvgComponent/commonSvgIcon';

import { withQuery } from '../../../hoc/withGraphql';

import s from './EditWishListGroup.css';
import bt from '../../../components/commonStyle.css';
const EditWishListComponent = ({ data: { loading, getWishListGroup } }) => {

	const { formatMessage } = useIntl();
	const dispatch = useDispatch();

	const deleteModalOpen = useSelector(state => state.modalStatus.deleteModalOpen);

	let initialValues = {};

	if (getWishListGroup?.id) {
		initialValues = {
			id: getWishListGroup?.id,
			name: getWishListGroup?.name,
			isPublic: getWishListGroup?.isPublic,
			userId: getWishListGroup?.userId
		};
	}

	if (getWishListGroup === null) return <NotFound />

	return (
		<>
			<WishListGroupModal actionType={'edit'} />
			<ConfirmationPopup
				modalStatus={deleteModalOpen}
				title={formatMessage(messages.wishList)}
				bodyText={formatMessage(messages.areYouSureDeleteWishList)}
				closeModal={() => dispatch(closeDeleteWishlistModal())}
				popupButtonLeftName={formatMessage(messages.cancel)}
				popupButtonRightName={formatMessage(messages.delete)}
				popupButtonLeftFunction={() => dispatch(closeDeleteWishlistModal())}
				popupButtonRightFunction={() => dispatch(deleteWishListGroup(getWishListGroup?.id))}
			/>
			<Grid fluid>
				<Row>
					<Col xs={12} sm={12} md={12} lg={12}>
						{
							loading && <>
								<Loader type="text" />
							</>
						}
						{
							!loading && getWishListGroup && <div className={cx(s.landingContent, s.noPadding)}>
								<div className={s.wishFlex}>
									<>
										<Link to={"/wishlists"} className={cx(s.button, s.resposiveBtn, s.innerPadding, s.goToALLText)}>
											<LinkIndicatePrevIcon className={cx(s.goToALLArrowIcon, s.iconCss, 'iconRotateRTL')} />{formatMessage(messages.goToAllLists)}
										</Link>
									</>

									<div className={cx(s.noPadding, s.textRight, s.btnFlex, 'footerBtnFlexRTL')}>
										<div className={cx(s.displayInlineBlock, 'shareIconRtl')}>
											<Button className={cx(s.button, s.noMargin, s.resposiveBtn, s.pullRghtNone)}
												onClick={() => dispatch(openAddWishListGroupModal(initialValues, 'EditWishListGroupForm'))}>
												<EditIcon className={cx(s.iconCss, 'iconCssRTL')} /> <span className={s.textDecoration}><FormattedMessage {...messages.editLabel} /></span>
											</Button>
										</div>
										<div className={cx(s.displayInlineBlock, 'shareIconRtl')}>
											<Button className={cx(s.button, s.modalCaptionLink, s.noMargin, bt.btnLarge, s.resposiveBtn, s.responsiveDeleteBtn, s.deleteBtnMargin)}
												onClick={() => dispatch(openDeleteWishlistModal())}>
												<DustPinIcon className={cx(s.iconCss, 'iconCssRTL')} /> <span className={s.textDecoration}><FormattedMessage {...messages.delete} /></span>
											</Button>
										</div>
									</div>
								</div>
								<h2 className={cx(s.landingTitle, s.innerPadding)}>
									{getWishListGroup?.name}
								</h2>
								{
									!loading && getWishListGroup && <>

										{
											getWishListGroup?.wishLists && getWishListGroup?.wishLists?.length > 0 && getWishListGroup?.wishListCount > 0 && <>
												{
													getWishListGroup?.wishLists?.map((item, index) => {
														if (item?.listData != null) {
															return (
																<div key={index} className={s.listingSection}>
																	<CommonListingItems
																		id={item?.listData?.id}
																		title={item?.listData?.title}
																		basePrice={item?.listData?.listingData?.basePrice}
																		roomType={item?.listData?.settingsData[0]?.listsettings?.itemName}
																		coverPhoto={item?.listData?.coverPhoto}
																		listPhotos={item?.listData?.listPhotos}
																		wishListStatus={item?.listData?.wishListStatus}
																		currency={item.listData.listingData.currency}
																		bookingType={item.listData.bookingType}
																		reviewsCount={item.listData.reviewsCount}
																		reviewsStarRating={item.listData.reviewsStarRating}
																		beds={item.listData.beds}
																		userId={item.listData.userId}
																		city={item.listData.city}
																		state={item.listData.state}
																		isListingSwiper
																	/>
																</div>
															)
														}
													})
												}
											</>
										}
										{
											getWishListGroup?.wishListCount == 0 && <div>
												<h3 className={cx(s.innerPadding, s.errorCss)}>{formatMessage(messages.noWishlistsHomes)}</h3>
												<Link to={'/s'} className={bt.btnPrimary}>{formatMessage(messages.startExplore)}</Link>
											</div>

										}
									</>
								}
							</div>
						}
					</Col>
				</Row>
			</Grid>
		</>
	)
}

EditWishListComponent.propTypes = {
	data: PropTypes.shape({
		loading: PropTypes.bool,
		getWishListGroup: PropTypes.any
	}),
};

EditWishListComponent.defaultProps = {
	data: { loading: true }
}

export default compose(
	withStyles(s, bt),
	withQuery(getWishListGroupQuery,
		{
			options: (props) => ({
				variables: {
					profileId: props.profileId,
					id: Number(props.wishListId)
				},
				fetchPolicy: 'network-only',
				ssr: false
			})
		}
	)
)(EditWishListComponent);
